/**
 *
 * @param id {string} - feature_id
 * @param flags {array} - Flag list
 * @return {Boolean}
 */
import store from '@/vuex/vuex';

export default id => {
  if (!id) return true;

  let flags;

  // DevTools
  const devToolsEnabled = store.state.devTools.isEnabled;
  if (devToolsEnabled) {
    flags = store.getters['devTools/getFlags'];
  } else {
    flags = store.state.globalFlags.flags.data;
  }

  const target = flags.find(flag => flag.feature_id === id);
  if (!target) return false;

  return target.enabled;
};
